<template>
  <!-- 注册头 -->
      <div style="height: 80px;line-height: 80px;background-color: #6b646408;display: flex;justify-content: space-around;border: 1px solid #DDDDDD;">
        <!-- 头部左边 -->
        <div style="display: flex;margin-left: -15%">
          <!-- 图标 -->
          <div>
            <div style="float: left;margin-right: 8px;">
              <img style="width:120px;height: 45px; vertical-align: middle;border-radius: 10px;object-fit: contain;"
                   src="../../assets/zch-logo.png" />
            </div>
            <div style="width: 170px; height: 80px;line-height: 80px;display: flex;flex-wrap: wrap;">
              <div style="height: 24px;font-size: 23px;font-weight: bold;color: #5d5d5d;">真会采商城</div>
              <!--<div style="font-size: 12px;text-indent: 0px;color: #848484c7;">RzCloud</div>-->
            </div>
          </div>
          <div style="border-left:1px solid #d6d6d6e0;height: 45px;margin: 18px 17px 17px 17px;">
          </div>
          <div>
            <span style="color: #cecece;">{{titleName}}</span>
          </div>
        </div>
        <div style="display: flex;margin-right: -15%;color:#cecece;">
          <div v-if="step=='step'">
<!--              <userInfo></userInfo>-->
          </div>
          <div v-else>
              <router-link to="login"><span>返回首页</span></router-link>
          </div>

        </div>
      </div>
</template>

<script>
   export default {
     props:["titleName","step"],
   }
</script>

<style>
</style>
